import Form from '@components/form/Form';
import FormRow from 'lib/src/components/form/FormRow';
import Modal from '@components/modal/Modal';
import React, { Dispatch, SetStateAction, useEffect } from 'react';

import useEditChallengeGroupScoreWeighting from './hooks/useEditChallengeGroupScoreWeighting';
import DataCheck from 'lib/src/components/common/DataCheck';
import { isEmpty } from 'lib/src/utils/generic';
import Slider from '@components/form/Silder';
import { DropdownOption } from 'lib/src/types/shared/DropdownOption';
import { ChallengeGroup } from 'src/types/shared/ChallengeGroup';
import Description from 'lib/src/components/typography/Description';

const stepMarkers: DropdownOption<number>[] = [0, 0.2, 0.4, 0.6, 0.8, 1].map(value => ({
    value,
    label: `${value * 100}%`,
}));

const EditChallengeGroupScoreWeightingModal: React.FC<EditChallengeLeadProps> = ({
    challengeGroup,
    setShowEditScoreWeightingModal,
}) => {
    const hideModal = () => setShowEditScoreWeightingModal(false);
    const {
        isFetching,
        fetchError,
        isPatching,
        patchError,
        patchSuccess,
        formState,
        handleChange,
        handleSubmit,
        prevSuccess,
    } = useEditChallengeGroupScoreWeighting(challengeGroup, hideModal);

    useEffect(() => {
        if (patchSuccess && !prevSuccess && !patchError) setShowEditScoreWeightingModal(false);
    }, [patchSuccess, prevSuccess, patchError, setShowEditScoreWeightingModal]);

    return (
        <Modal
            title="Edit challenge Group default score weighting"
            size="small"
            closeModal={hideModal}
        >
            <DataCheck
                dataExists={!isEmpty(challengeGroup)}
                isFetching={isFetching}
                error={fetchError}
            >
                <Form onCancel={hideModal} onSubmit={handleSubmit} isPosting={isPatching}>
                    <FormRow>
                        <Slider
                            name="deploymentScale"
                            value={formState.deploymentScale}
                            onChange={handleChange}
                            label="Deployment timescalescale (our view)"
                            min={0}
                            max={1}
                            step={0.01}
                            stepMarkers={stepMarkers}
                        />
                    </FormRow>
                    <FormRow>
                        <Slider
                            name="fitWithChallenge"
                            value={formState.fitWithChallenge}
                            onChange={handleChange}
                            label="Fit with challenge (cost/benefit)"
                            min={0}
                            max={1}
                            step={0.01}
                            stepMarkers={stepMarkers}
                        />
                    </FormRow>
                    <FormRow>
                        <Slider
                            name="credibilityCompany"
                            value={formState.credibilityCompany}
                            onChange={handleChange}
                            label="Credibility of company"
                            min={0}
                            max={1}
                            step={0.01}
                            stepMarkers={stepMarkers}
                        />
                    </FormRow>
                    <FormRow>
                        <Slider
                            name="credibilityTechnology"
                            value={formState.credibilityTechnology}
                            onChange={handleChange}
                            label="Credibility of technology"
                            min={0}
                            max={1}
                            step={0.01}
                            stepMarkers={stepMarkers}
                        />
                    </FormRow>
                    <FormRow>
                        <Slider
                            name="fullOrPartialSolution"
                            value={formState.fullOrPartialSolution}
                            onChange={handleChange}
                            label="Full or partial solution to specification of innovation challenge"
                            min={0}
                            max={1}
                            step={0.01}
                            stepMarkers={stepMarkers}
                        />
                    </FormRow>
                    <FormRow>
                        <Description>
                            Total:{' '}
                            {Math.round(
                                (formState.credibilityCompany +
                                    formState.credibilityTechnology +
                                    formState.deploymentScale +
                                    formState.fitWithChallenge +
                                    formState.fullOrPartialSolution) *
                                    100,
                            )}
                            %
                        </Description>
                    </FormRow>
                </Form>
            </DataCheck>
        </Modal>
    );
};

interface EditChallengeLeadProps {
    challengeGroup: ChallengeGroup;
    setShowEditScoreWeightingModal: Dispatch<SetStateAction<boolean>>;
}

export default EditChallengeGroupScoreWeightingModal;
